module.exports = __webpack_public_path__ + "img/AzadGulladin.053d549b.jpg";